import { defaultSoundPreferences } from '../notification-service-extension-shared'
import { NotificationType as NotificationFirebaseType } from '../notification-service-extension-shared/constants/firebase'
import { MIN_GAP_MS, SOUND_PREFS_KEY } from '@/features/notifications/constants/sound'
import { NotificationSoundPreferences } from '@/features/settings/types'
import AppPreferences from '@/modules/app-preferences'
import storage from '@/services/storage'
import { createAudioPlayer, setAudioModeAsync } from 'expo-audio'
import Constants from 'expo-constants'

class NotificationSoundService {
    private player: ReturnType<typeof createAudioPlayer> | null = null
    private lastPlayAt = 0
    private initPromise: Promise<void> | null = null

    async play() {
        await this.ensureInitialized()

        const now = Date.now()
        if (now - this.lastPlayAt < MIN_GAP_MS) return
        this.lastPlayAt = now

        await this.player?.seekTo(0)
        await this.player?.play()
    }

    async preload() {
        await this.ensureInitialized()
    }

    private async ensureInitialized() {
        if (this.player) return

        if (!this.initPromise) {
            this.initPromise = (async () => {
                await setAudioModeAsync({ playsInSilentMode: true })

                const source = require('@/assets/sounds/alert.wav')
                this.player = createAudioPlayer(source)
            })().catch((err) => {
                this.player = null
                this.initPromise = null
                throw err
            })
        }

        return this.initPromise
    }
}

const notificationSoundService = new NotificationSoundService()

export const initNotificationSound = async () => notificationSoundService.preload()

export const playNotificationSound = async () => notificationSoundService.play()

export const isSoundEnabled = async (type: NotificationFirebaseType): Promise<boolean> => {
    let soundPrefs = await storage.getNotificationSoundPreferences()
    return soundPrefs?.[type] ?? defaultSoundPreferences[type] ?? true
}

export async function saveSoundPrefsToAppGroup(prefs: NotificationSoundPreferences) {
    AppPreferences.set(
        SOUND_PREFS_KEY,
        JSON.stringify(prefs),
        Constants.expoConfig?.ios?.entitlements?.['com.apple.security.application-groups'][0]
    )
}
